import React, { useMemo } from "react";
import { sanitizeHtml } from "../../../../../../../utils/sanitizeHtml";

const HtmlSourceSection = ({ html_text, handleHtmlTextChange }) => {
  const preview = useMemo(() => sanitizeHtml(html_text || ""), [html_text]);

  return (
    <div className="html-source-section">
      <textarea
        className="html-source-section__textarea"
        value={html_text || ""}
        onChange={(e) => handleHtmlTextChange(e.target.value)}
        placeholder="<div>Paste your HTML code here</div>"
        style={{ width: "100%", height: "150px", fontFamily: "monospace", fontSize: "13px" }}
      />
      <div className="html-source-section__hint" style={{ fontSize: "12px", color: "#8a8a8f", margin: "8px 0 4px" }}>
        Scripts and unsafe attributes are stripped before this is shown to recipients. Preview:
      </div>
      <div
        className="html-source-section__preview"
        style={{ border: "1px solid #e6e6e8", borderRadius: "6px", padding: "8px", minHeight: "60px" }}
        dangerouslySetInnerHTML={{ __html: preview }}
      />
    </div>
  );
};

export default HtmlSourceSection;
